
export const USER_DATA = "user"
export const TOKEN = "token"
export const SELLER_DETAILS = "sellerDetails"
